import React from 'react'
// import { ContentCardType } from '../ContentCardType'
import { ContentCardType } from '@futures-platform/ui'
import Tooltip from '@mui/material/Tooltip'
import { phenomenonColor } from '../../helpers/phenomenonColor'
import { isEmpty } from '../../helpers/utils'
import { translatePhenomenonAlias } from '../../helpers/utils'
import styles from './ContentCard.module.css'

const ContentCard = ({ phenomenon, lang, phenomenonType, href, isAuthed }) => {
  let fontSizePhen = 16
  let fontSizePhenIcon = 24

  const phenomenonTypeData = React.useMemo(() => {
    return !!phenomenonType?.length && !!phenomenon?.content?.type
      ? phenomenonType?.filter((type) => type?.id === phenomenon?.content?.type)
      : []
  }, [phenomenonType, phenomenon])

  const completedPhenomenon = React.useMemo(() => {
    let phenTemp = !!phenomenon ? { ...phenomenon } ?? {} : {}

    phenTemp['color'] =
      !!phenomenon &&
      !!phenomenonTypeData &&
      !!phenomenonTypeData?.length &&
      !!phenomenonTypeData[0]?.style?.color &&
      phenomenon?.content?.type?.includes('fp:doc-types')
        ? phenomenonTypeData[0]?.style?.color || 'none'
        : 'none'
    if (
      phenTemp['color'] === 'none' &&
      !phenomenonTypeData?.length &&
      !!phenomenon?.content?.type?.includes('fp:doc-types')
    ) {
      phenTemp['content-type-alias'] = 'undefined'
      phenTemp['content-type-title'] = '(no type)'
    } else {
      phenTemp['content-type-alias'] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.alias
      phenTemp['content-type-title'] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.title
    }

    phenTemp['phen-data'] = { ...phenomenon }
    phenTemp['phenomenonType'] = !!phenomenonType && [...phenomenonType]
    phenTemp['links'] = !!phenomenon?.content?.links
      ? [...phenomenon?.content?.links]
      : null

    // phenTemp['newsFeeds'] = newsFeed
    phenTemp['newsFeeds'] = phenomenon?.newsFeeds

    return phenTemp
  }, [phenomenonType, phenomenon, phenomenonTypeData])
  const { translationTitle } = translatePhenomenonAlias(
    completedPhenomenon,
    lang,
  )
  const isFpGroup =
    Number(completedPhenomenon?.group) === 0 ||
    (!!completedPhenomenon?.groups?.length &&
      Number(completedPhenomenon?.groups[0]) === 0)

  const leftPosition = completedPhenomenon['leftPostion1st']
  const top = completedPhenomenon['topPostion1st']
  // 14px -> 0 %
  // 218 px -> 50 %
  // 450 px -> 100%

  // const plusHowManyPxFromTheLowestPx1 = (11.5 * range1) / 50
  const title =
    completedPhenomenon?.content?.short_title ||
    completedPhenomenon?.content?.title
  let fontSizePhenomenonTitle = '12px'
  if (document.body.clientWidth <= 800 && document.body.clientWidth > 450)
    fontSizePhenomenonTitle = '11px'
  else if (document.body.clientWidth <= 450 && document.body.clientWidth >= 400)
    fontSizePhenomenonTitle = '10px'
  else if (document.body.clientWidth < 400) fontSizePhenomenonTitle = '9px'

  return !!completedPhenomenon && !isEmpty(completedPhenomenon) ? (
    <Tooltip
      // placement="bottom-start"
      title={
        completedPhenomenon?.content?.title ||
        completedPhenomenon?.content?.short_title
      }>
      <div
        className={
          !!isAuthed
            ? 'related-Phenomena content-card left'
            : 'related-Phenomena'
        }
        data-href={!!isAuthed ? href : null}
        style={{
          display: 'flex',
          width: 'fit-content',
          position: 'absolute',
          top: top + 'px',
          left: leftPosition,
          fontSize: fontSizePhen + 'px',
          alignItems: 'center',
          cursor: 'pointer',
          flexDirection: 'column',
        }}>
        <div className={styles.cardHeaderWrapper}>
          <div className={styles.headerWrapper}>
            {/* {completedPhenomenon?.['content-type-alias'] !== null && (
              <div className={styles.contentCardWrapper}>
                <ContentCardType
                  // fontSizePhen={completedPhenomenon['fontSizePhenIcon']}
                  // phenomenon={completedPhenomenon}
                  // isFpGroup={isFpGroup}
                  customTypeStyleColor={completedPhenomenon?.color}
                  contentType={completedPhenomenon?.['content-type-alias']}
                  isFpGroup={isFpGroup}
                />
              </div>
            )} */}
            <div className={styles.contentCardWrapper}>
              <ContentCardType
                fontSizePhen={completedPhenomenon['fontSizePhenIcon']}
                // phenomenon={completedPhenomenon}
                // isFpGroup={isFpGroup}
                customTypeStyleColor={completedPhenomenon?.color}
                contentType={completedPhenomenon?.['content-type-alias']}
                isFpGroup={isFpGroup}
              />
            </div>
          </div>
        </div>

        <span
          className={styles.h1Title}
          style={{
            maxWidth: document.body.clientWidth > 600 ? '230px' : '80px',
            fontSize: fontSizePhenomenonTitle,
          }}>
          {title}
        </span>
      </div>
    </Tooltip>
  ) : null
}

export default ContentCard
